import { Accordion, Nav } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

function T8_tomi8_api_menu({ setactivity, activeItem }) {
  const navigate = useNavigate();
  const activeStyles = { fontWeight: 600, backgroundColor: '#e7f1ff', color: '#0d6efd' };

  return (
    <Accordion.Item eventKey="10">
      <Accordion.Header>
        <span role="img" aria-label="api">
          📡
        </span>{' '}
        TOMi8 API
      </Accordion.Header>
      <Accordion.Body className="p-0">
        <Nav className="flex-column">
          <Nav.Link
            active={activeItem === 'tomi8_api_docs'}
            style={activeItem === 'tomi8_api_docs' ? activeStyles : undefined}
            onClick={() => {
              navigate('/tomi8-api');
              setactivity('TOMi8Api');
            }}
          >
            Manual API (Swagger)
          </Nav.Link>
        </Nav>
      </Accordion.Body>
    </Accordion.Item>
  );
}

export default T8_tomi8_api_menu;
